import * as d3 from 'd3'

export default {
  methods: {

    chart_Router() {
      this.canvasChart = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.chart.group.forEach((d,i)=> {
        
        let chtData = this.chartData.filter(f=> f[this.radio.radioCode] == this.current.value && f[this.chart.chartCode] == d.value )

        if(!this.current.start) this.current.start = d3.min(chtData, c => c.CDATE)
        if(!this.current.end) this.current.end = d3.max(chtData, c => c.CDATE)

        chtData = chtData.filter(f=> f.CDATE >= this.current.start && f.CDATE <= this.current.end)

        this.set_maxValue(chtData) //-----> below
        this.draw_ChartCanvas(d) //-----> draw_ChartCanvas.js
        this.draw_Timeline(chtData, d) //-----> draw_Timeline.js
        this.chart_Controller(chtData, d) //-----> draw_Chart.js
        
      })
      
    },


    set_maxValue(chtDate) {

      // Initial
      this.primary.max = null
      this.primary.axis = null
      this.secondary.max = null
      this.secondary.axis = null

      // Setting Primary
      if(this.primary.maxValue == 0) {
        let maxArray = []
        this.chart.styles.filter(f=> f.type == 'BAR').forEach(s => {
          maxArray.push(d3.max(chtDate, c => +c[s.code]))
        })
        this.primary.max = this.gmx_maxBound5(d3.max(maxArray))
      } else {
        this.primary.max = this.primary.maxValue
      }

      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range([0, this.chart.height])
      this.primary.titleX = (this.primary.position=='left') ? -this.primary.padding : this.chart.width + this.primary.padding
      this.primary.axisX = (this.primary.position=='left') ? 0 : this.chart.width


      // Setting secondary
      if(this.secondary.maxValue == 0) {
      let maxArray = []
      this.chart.styles.filter(f=> f.type == 'LINE').forEach(s => {
        maxArray.push(d3.max(chtDate, c => +c[s.code]))
      })
      this.secondary.max = this.gmx_maxBound5(d3.max(maxArray))
      } else {
        this.secondary.max = this.secondary.maxValue
      }

      this.secondary.axis = d3.scaleLinear()
      .domain([0, this.secondary.max])
      .range([this.chart.height, 0])
      this.secondary.titleX = (this.secondary.position=='left') ? -this.secondary.padding : this.chart.width + this.secondary.padding
      this.secondary.axisX = (this.secondary.position=='left') ? 0 : this.chart.width

    },

  }
}
